import {
  AskRedoCapabilityBlockOutputSchema,
  type AskRedoCapabilityPresentation,
} from "@redotech/redo-settings-common/ask-redo-capabilities";

export const SHOW_CAPABILITY_BLOCK_TOOL_NAME = "show_capability_block";

export type CapabilityBlockData = AskRedoCapabilityPresentation;

export type CapabilityBlockRenderData =
  | { kind: "presentation"; presentation: CapabilityBlockData }
  | { kind: "fallback" };

export function tryParseCapabilityBlockOutput(
  output: unknown,
): CapabilityBlockData | null {
  const parsed = AskRedoCapabilityBlockOutputSchema.safeParse(output);
  return parsed.success ? parsed.data.capabilityBlock : null;
}

export function parseCapabilityBlockRenderData(
  output: unknown,
): CapabilityBlockRenderData {
  const presentation = tryParseCapabilityBlockOutput(output);
  return presentation
    ? { kind: "presentation", presentation }
    : { kind: "fallback" };
}
